import React from "react";
import { Box, Typography } from "@mui/material";

interface State { hasError: boolean; }

class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "#f8f9fb",
            gap: 2,
            px: 3,
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "1.8rem", md: "2.5rem" },
              fontWeight: 300,
              letterSpacing: "-0.02em",
              color: "#1D2F41",
              fontFamily: '"Segoe UI", sans-serif',
            }}
          >
            Something went wrong.
          </Typography>
          <Typography
            sx={{
              fontSize: "1rem",
              color: "rgba(29,47,65,0.55)",
              fontFamily: '"Calibri", sans-serif',
              fontWeight: 300,
            }}
          >
            Please refresh the page or{" "}
            <Box
              component="a"
              href="mailto:info@kanonics.com"
              sx={{ color: "#2b6161", textDecoration: "underline" }}
            >
              contact us
            </Box>{" "}
            if the problem persists.
          </Typography>
          <Box
            component="button"
            onClick={() => window.location.reload()}
            sx={{
              mt: 2,
              px: 3,
              py: 1.5,
              border: "1px solid rgba(29,47,65,0.2)",
              bgcolor: "transparent",
              color: "#1D2F41",
              fontFamily: '"Calibri", sans-serif',
              fontSize: "0.9rem",
              cursor: "pointer",
              "&:hover": { bgcolor: "rgba(29,47,65,0.05)" },
            }}
          >
            Refresh page
          </Box>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
